import { SxProps, Theme } from '@mui/system';

export const inputWrapper: SxProps<Theme> = {
    mt: "12px",
};